/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-interface */
import * as React from 'react';
import Modal from '../Modal';
import { ConteudoPortal } from './Content';

interface IModalGerarTicketQrCode {
  title: string;
  handleClose: () => void;
  show: boolean;
  sgl?: string;
  code?: string;
}

const ModalPortalPrivacidade: React.FC<IModalGerarTicketQrCode> = ({
  title,
  handleClose,
  show,
  sgl,
  code,
}) => {
  return (
    <Modal
      title={title}
      handleClose={handleClose}
      show={show}
      style={{ width: 'auto', minWidth: '400px', maxHeight: '85vh' }}
    >
      <ConteudoPortal handleClose={handleClose} sgl={sgl} code={code} />
    </Modal>
  );
};

export { ModalPortalPrivacidade };
